// screens/create-product-mgt/AddProduct.jsx
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Spinner, Card } from 'react-bootstrap';
import Select from "react-select";
import { TagsInput } from 'react-tag-input-component';
import makeAnimated from "react-select/animated";
import { toast } from 'react-toastify';
import axios from '../../api/axios';

const AddProduct = ({ data, onNext, onBack, updateData, currentStep, isSubmitting, setIsSubmitting, setErrors, isProductCreated }) => {
    const accessToken = localStorage.getItem('authToken');
    const productId = localStorage.getItem('productId');

    const [isLoading, setIsLoading] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [productTags, setProductTags] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedExcludedOutlets, setSelectedExcludedOutlets] = useState([]);
    const [selectedNature, setSelectedNature] = useState([]);
    const [selectedKeywords, setSelectedKeywords] = useState([]);
    const [displayPreview, setDisplayPreview] = useState(null);
    const [coverPreview, setCoverPreview] = useState(null);

    const [isNowEditForm, setIsNowEditForm] = useState(false);
    const [editedData, setEditedData] = useState({});
    const [editSelectedExcludedOutlets, setEditSelectedExcludedOutlets] = useState([]);
    const [editSelectedNature, setEditSelectedNature] = useState([]);
    const [editSelectedKeywords, setEditSelectedKeywords] = useState([]);

    const animatedComponents = makeAnimated();
    const product = data.product || {};

    useEffect(() => {
        console.log("After come back in Add product");

        fetchCategoryList();
        fetchOutlets();
    }, []);

    useEffect(() => {
        if (searchText.length > 2) {
            fetchProductTags(searchText);
        }
    }, [searchText]);

    useEffect(() => {
        console.log("Trying 1", productId);
        console.log("Product Created in Add Product :", isProductCreated);


        if (productId && isProductCreated) {
            console.log("Hi Hello in use Effect :");

            getEditingProductDetails(productId);
        }
    }, [isProductCreated]);

    const fetchCategoryList = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response.data.data.categories);
            }
        } catch (error) {
            toast.error("Failed to load categories", { position: "top-right" });
        }
    };

    const fetchProductTags = async (text) => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get(`/product/tags?search=${text}`, { headers });

            if (response?.data?.status === true) {
                setProductTags(response.data.data.productTags);
            }
        } catch (error) {
            // Silently fail
        }
    };

    const fetchOutlets = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response.data.data.outlets);
            }
        } catch (error) {
            toast.error("Failed to load outlets", { position: "top-right" });
        }
    };

    const getEditingProductDetails = async (prodId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`  // Fixed typo: Auhtorization -> Authorization
            };

            const response = await axios.get(`product?_id=${prodId}`, { headers }); // Added headers
            console.log("Response of getEditingProductDetails :", response);

            let productData = response?.data?.data?.products;
            console.log("Product Data from getEditingProductDetails :", response);

            if (response?.data?.status === true && productData) {
                setIsNowEditForm(true);

                // Set edited data without duplicate taxPercent
                setEditedData({
                    _id: productData._id,
                    sequenceNumber: productData?.sequenceNumber || '',
                    name: productData.name || '',
                    description: productData.description || '',
                    hsn: productData.hsn || '',
                    taxPercent: productData.taxPercent || '',  // Fixed: removed duplicate
                    makingTime: productData.makingTime || '',
                    mrp: productData.mrp || '',
                    status: productData?.status || '',
                    category: productData?.category?._id || '',
                    offerPrice: productData?.offerPrice || '',
                    foodType: productData?.foodType || '',
                    classType: productData?.classType || '',
                    productTagId: productData?.productTag?._id || '',
                    productTagName: productData?.productTag?.tagName || '',
                    isEventProduct: productData?.isEventProduct || false,
                    isFreebieProduct: productData?.isFreebieProduct,
                    calories: productData?.calories || '',
                    weight: productData?.weight || '',
                    weightUnit: productData?.weightUnit || '',
                    orderType: productData?.orderType || 'ALL',
                    isNewProduct: productData?.isNewProduct || false,
                    productCost: productData?.productCost || 0
                });

                // Set keywords if they exist
                if (productData.keywords) {
                    const keywordsArray = productData.keywords.split(',').filter(k => k.trim() !== '');
                    setEditSelectedKeywords(keywordsArray);
                    setSelectedKeywords(keywordsArray); // Also update the main state
                }

                // Set excluded outlets
                if (productData?.excludedOutletDetails?.length > 0) {
                    const mappedSelectedExOutlet = productData.excludedOutletDetails.map(m => ({
                        value: m?._id,
                        label: `${m?.name}${m?.city ? ` (${m.city})` : ''}`
                    }));
                    setEditSelectedExcludedOutlets(mappedSelectedExOutlet);
                    setSelectedExcludedOutlets(mappedSelectedExOutlet); // Also update the main state
                }

                // Set product nature
                if (productData?.productsNature?.length > 0) {
                    setEditSelectedNature([...productData.productsNature]);
                    setSelectedNature([...productData.productsNature]); // Also update the main state
                }

                // Update the main data state
                updateData('product', {
                    ...productData,
                    category: productData?.category?._id || '',
                    productTagId: productData?.productTag?._id || '',
                    productTagName: productData?.productTag?.tagName || '',
                    isFreebieProduct: productData?.isFreebieProduct || '' // Added new field
                });
            }
        } catch (error) {
            setIsNowEditForm(false);
            console.log("Error in Fetching Updating Product Details :", error);
            toast.error("Failed to load product details", { position: "top-right" });
        }
    };

    console.log("Outside Everything isNowEditForm :", isNowEditForm);


    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        // Handle file uploads and previews
        if (name === "displayImage" && files[0]) {
            const file = files[0];
            setDisplayPreview(URL.createObjectURL(file));

            // Validate image dimensions for displayImage
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        if (img.width === 400 && img.height === 400) {
                            updateData('product', { [name]: file });
                        } else {
                            toast.error(`Product image must be exactly 400x400 pixels. Current: ${img.width}x${img.height}`);
                            e.target.value = '';
                            setDisplayPreview(null);
                        }
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
            return;
        }

        if (name === "coverPicture" && files[0]) {
            const file = files[0];
            setCoverPreview(URL.createObjectURL(file));
            updateData('product', { [name]: file });
            return;
        }

        // Handle regular input changes
        if (isNowEditForm) {
            // If editing, update editedData state
            setEditedData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        // Always update the main product data
        updateData('product', { [name]: value });
    };

    // const handleNextStep = async () => {
    //     // Determine which data to use based on edit mode
    //     const currentProduct = isNowEditForm ? editedData : product;

    //     // Use appropriate arrays based on mode
    //     const currentKeywords = isNowEditForm ? editSelectedKeywords : selectedKeywords;
    //     const currentSelectedOutlets = isNowEditForm ? editSelectedExcludedOutlets : selectedExcludedOutlets;
    //     const currentSelectedNature = isNowEditForm ? editSelectedNature : selectedNature;

    //     // Validate required fields - including isFreebieProduct
    //     let requiredFields = [
    //         'sequenceNumber', 'name', 'category', 'mrp', 'offerPrice',
    //         'classType', 'foodType', 'hsn', 'taxPercent', 'weight',
    //         'weightUnit', 'calories', 'makingTime', 'orderType',
    //         'isEventProduct', 'isNewProduct', 'isFreebieProduct' // Added new field
    //     ];

    //     // ✅ Only require pricing if NOT a freebie
    //     if (!currentProduct?.isFreebieProduct) {
    //         requiredFields.push('mrp', 'offerPrice');
    //     }


    //     const missingFields = requiredFields.filter(field => {
    //         const value = currentProduct[field];
    //         return value === undefined || value === null || value === '';
    //     });

    //     if (missingFields.length > 0) {
    //         toast.error(`Please fill in all required fields. Missing: ${missingFields.join(', ')}`, { position: "top-right" });
    //         return;
    //     }

    //     // Validate keywords
    //     if (currentKeywords.length === 0) {
    //         toast.error("Product keywords is required", { position: "top-right" });
    //         return;
    //     }

    //     // Validate image for new products
    //     if (!isNowEditForm && !product?.displayImage) {
    //         toast.error("Please upload a product image (400x400)", { position: "top-right" });
    //         return;
    //     }

    //     setIsLoading(true);
    //     setIsSubmitting(true);

    //     try {
    //         const formData = new FormData();

    //         // Handle file uploads - only append if it's a File object (not a string/URL)
    //         if (product.displayImage && typeof product.displayImage !== 'string') {
    //             formData.append("displayImage", product.displayImage);
    //         }

    //         if (product.coverPicture && typeof product.coverPicture !== 'string') {
    //             formData.append("coverPicture", product.coverPicture);
    //         }

    //         // Append all product data fields - including isFreebieProduct
    //         const fieldsToAppend = [
    //             'sequenceNumber', 'category', 'name', 'description', 'hsn', 'taxPercent',
    //             'makingTime', 'mrp', 'offerPrice', 'productCost', 'foodType', 'classType',
    //             'calories', 'weight', 'weightUnit', 'isEventProduct', 'isNewProduct',
    //             'isFreebieProduct', 'orderType' // Added new field
    //         ];

    //         fieldsToAppend.forEach(field => {
    //             if (currentProduct[field] !== undefined && currentProduct[field] !== null) {
    //                 formData.append(field, currentProduct[field]);
    //             }
    //         });

    //         // Handle keywords - ONLY ONCE as comma-separated string
    //         if (currentKeywords.length > 0) {
    //             // Clean and validate keywords
    //             const cleanedKeywords = currentKeywords
    //                 .map(keyword => keyword.trim())
    //                 .filter(keyword => keyword !== '');

    //             if (cleanedKeywords.length === 0) {
    //                 toast.error("Please enter valid keywords", { position: "top-right" });
    //                 setIsLoading(false);
    //                 setIsSubmitting(false);
    //                 return;
    //             }

    //             const keywordsString = cleanedKeywords.join(',');
    //             console.log('Keywords being sent:', keywordsString); // Debug log
    //             formData.append("keywords", keywordsString);
    //         }

    //         // Handle product tag - use bracket notation correctly
    //         if (currentProduct.productTagId) {
    //             formData.append("productTag[productTagId]", currentProduct.productTagId);
    //         }

    //         if (currentProduct.productTagName) {
    //             formData.append("productTag[productTagName]", currentProduct.productTagName);
    //         }

    //         // Handle excluded outlets - only if any selected
    //         if (currentSelectedOutlets?.length > 0) {
    //             currentSelectedOutlets.forEach((outlet, index) => {
    //                 if (outlet && outlet.value) {
    //                     formData.append(`excludedOutlets[${index}]`, outlet.value);
    //                 }
    //             });
    //         } else {
    //             // If no outlets excluded, you might want to send empty array or omit
    //             // formData.append("excludedOutlets", "[]");
    //         }

    //         // Handle product nature - only if any tags added
    //         if (currentSelectedNature?.length > 0) {
    //             // Clean and validate nature tags
    //             const cleanedNatureTags = currentSelectedNature
    //                 .map(tag => tag.trim())
    //                 .filter(tag => tag !== '');

    //             cleanedNatureTags.forEach((nature, index) => {
    //                 formData.append(`productsNature[${index}]`, nature);
    //             });
    //         } else {
    //             // If no nature tags, you might want to send empty array
    //             // formData.append("productsNature", "[]");
    //         }

    //         // Debug: Log FormData entries
    //         console.log("FormData entries:");
    //         for (let [key, value] of formData.entries()) {
    //             console.log(key, ":", value);
    //         }

    //         const headers = {
    //             "Content-Type": "multipart/form-data",
    //             Authorization: `Bearer ${accessToken}`,
    //         };

    //         let response;
    //         console.log("IsNowEditForm :", isNowEditForm);

    //         if (isNowEditForm) {
    //             // Update existing product
    //             formData.append("_id", currentProduct._id);
    //             console.log("Updating product with ID:", currentProduct._id);
    //             response = await axios.put("product", formData, { headers });
    //         } else {
    //             // Create new product
    //             console.log("Creating new product");
    //             response = await axios.post("product", formData, { headers });
    //             // getEditingProductDetails(response?.data?.data?.dbResponse?._id)
    //         }

    //         if (response?.data?.status === true) {
    //             const productId = response?.data?.data?.dbResponse?._id || currentProduct._id;

    //             // Update with product ID
    //             const finalProduct = {
    //                 ...currentProduct,
    //                 _id: productId
    //             };

    //             // Store productId in localStorage
    //             localStorage.setItem("productId", productId);

    //             updateData('product', finalProduct);

    //             toast.success(isNowEditForm ? "Product updated successfully!" : "Product created successfully!", {
    //                 position: "top-right"
    //             });

    //             // Reset states for new product creation
    //             if (!isNowEditForm) {
    //                 setSelectedExcludedOutlets([]);
    //                 setSelectedKeywords([]);
    //                 setSelectedNature([]);
    //                 setDisplayPreview(null);
    //                 setCoverPreview(null);
    //             }

    //             onNext();
    //         } else {
    //             const errorMsg = response?.data?.error || "Failed to save product";
    //             console.error("API Error:", errorMsg);
    //             toast.error(errorMsg, { position: "top-right" });
    //         }
    //     } catch (error) {
    //         console.error('Error saving product:', error);

    //         let errorMessage = '';
    //         if (error?.response) {
    //             console.error("Error response data:", error.response.data);
    //             console.error("Error response status:", error.response.status);

    //             if (error.response?.status === 406) {
    //                 errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
    //             } else if (error.response?.status === 412) {
    //                 errorMessage = error?.response?.data?.data?.message;
    //             } else if (error.response?.status === 400) {
    //                 errorMessage = error?.response?.data?.error;
    //             } else if (error.response?.status === 500) {
    //                 errorMessage = error?.response?.data?.message || error?.response?.data?.error;
    //             }
    //         }

    //         toast.error(errorMessage || "Failed to save product", {
    //             position: "top-right",
    //             autoClose: 3000,
    //             theme: "colored",
    //         });
    //     } finally {
    //         setIsLoading(false);
    //         setIsSubmitting(false);
    //     }
    // };

    const handleNextStep = async () => {
        // Determine which data to use based on edit mode
        const currentProduct = isNowEditForm ? editedData : product;

        // ✅ Force prices to 0 for freebie products
        if (currentProduct?.isFreebieProduct === true) {
            console.log("Hello In If Statement :", currentProduct?.isFreebieProduct);
            
            currentProduct.mrp = 0;
            currentProduct.offerPrice = 0;
        } else {
            // optional hardening
            console.log("Hello in Else Statement");
            currentProduct.mrp = currentProduct.mrp
            currentProduct.offerPrice = currentProduct.offerPrice
        }

        // Use appropriate arrays based on mode
        const currentKeywords = isNowEditForm ? editSelectedKeywords : selectedKeywords;
        const currentSelectedOutlets = isNowEditForm ? editSelectedExcludedOutlets : selectedExcludedOutlets;
        const currentSelectedNature = isNowEditForm ? editSelectedNature : selectedNature;

        // ✅ Required fields (pricing conditional)
        let requiredFields = [
            'sequenceNumber', 'name', 'category',
            'classType', 'foodType', 'hsn', 'taxPercent', 'weight',
            'weightUnit', 'calories', 'makingTime', 'orderType',
            'isEventProduct', 'isNewProduct', 'isFreebieProduct'
        ];

        // Only require pricing if NOT a freebie
        if (!currentProduct?.isFreebieProduct) {
            requiredFields.push('mrp', 'offerPrice');
        }

        const missingFields = requiredFields.filter(field => {
            const value = currentProduct[field];
            return value === undefined || value === null || value === '';
        });

        if (missingFields.length > 0) {
            toast.error(
                `Please fill in all required fields. Missing: ${missingFields.join(', ')}`,
                { position: "top-right" }
            );
            return;
        }

        // Validate keywords
        if (currentKeywords.length === 0) {
            toast.error("Product keywords is required", { position: "top-right" });
            return;
        }

        // Validate image for new products
        if (!isNowEditForm && !product?.displayImage) {
            toast.error("Please upload a product image (400x400)", { position: "top-right" });
            return;
        }

        setIsLoading(true);
        setIsSubmitting(true);

        try {
            const formData = new FormData();

            // File uploads
            if (product.displayImage && typeof product.displayImage !== 'string') {
                formData.append("displayImage", product.displayImage);
            }

            if (product.coverPicture && typeof product.coverPicture !== 'string') {
                formData.append("coverPicture", product.coverPicture);
            }

            // Product fields
            const fieldsToAppend = [
                'sequenceNumber', 'category', 'name', 'description', 'hsn', 'taxPercent',
                'makingTime', 'mrp', 'offerPrice', 'productCost', 'foodType', 'classType',
                'calories', 'weight', 'weightUnit', 'isEventProduct', 'isNewProduct',
                'isFreebieProduct', 'orderType'
            ];

            fieldsToAppend.forEach(field => {
                if (currentProduct[field] !== undefined && currentProduct[field] !== null) {
                    formData.append(field, currentProduct[field]);
                }
            });

            // Keywords
            if (currentKeywords.length > 0) {
                const cleanedKeywords = currentKeywords
                    .map(keyword => keyword.trim())
                    .filter(keyword => keyword !== '');

                if (cleanedKeywords.length === 0) {
                    toast.error("Please enter valid keywords", { position: "top-right" });
                    setIsLoading(false);
                    setIsSubmitting(false);
                    return;
                }

                formData.append("keywords", cleanedKeywords.join(','));
            }

            // Product tag
            if (currentProduct.productTagId) {
                formData.append("productTag[productTagId]", currentProduct.productTagId);
            }

            if (currentProduct.productTagName) {
                formData.append("productTag[productTagName]", currentProduct.productTagName);
            }

            // Excluded outlets
            if (currentSelectedOutlets?.length > 0) {
                currentSelectedOutlets.forEach((outlet, index) => {
                    if (outlet?.value) {
                        formData.append(`excludedOutlets[${index}]`, outlet.value);
                    }
                });
            }

            // Product nature
            if (currentSelectedNature?.length > 0) {
                const cleanedNatureTags = currentSelectedNature
                    .map(tag => tag.trim())
                    .filter(tag => tag !== '');

                cleanedNatureTags.forEach((nature, index) => {
                    formData.append(`productsNature[${index}]`, nature);
                });
            }

            // Debug
            console.log("FormData entries:");
            for (let [key, value] of formData.entries()) {
                console.log(key, ":", value);
            }

            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${accessToken}`,
            };

            let response;

            if (isNowEditForm) {
                formData.append("_id", currentProduct._id);
                response = await axios.put("product", formData, { headers });
            } else {
                response = await axios.post("product", formData, { headers });
            }

            if (response?.data?.status === true) {
                const productId =
                    response?.data?.data?.dbResponse?._id || currentProduct._id;

                const finalProduct = {
                    ...currentProduct,
                    _id: productId
                };

                localStorage.setItem("productId", productId);
                updateData('product', finalProduct);

                toast.success(
                    isNowEditForm
                        ? "Product updated successfully!"
                        : "Product created successfully!",
                    { position: "top-right" }
                );

                if (!isNowEditForm) {
                    setSelectedExcludedOutlets([]);
                    setSelectedKeywords([]);
                    setSelectedNature([]);
                    setDisplayPreview(null);
                    setCoverPreview(null);
                }

                onNext();
            } else {
                const errorMsg = response?.data?.error || "Failed to save product";
                toast.error(errorMsg, { position: "top-right" });
            }
        } catch (error) {
            console.error('Error saving product:', error);

            let errorMessage = '';
            if (error?.response) {
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error || error?.response?.data?.data?.message;;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 400) {
                    errorMessage = error?.response?.data?.error;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.message || error?.response?.data?.error;
                }
            }

            toast.error(errorMessage || "Failed to save product", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    };

    const outletOptions = outlets.map(outlet => ({
        value: outlet._id,
        label: `${outlet.name}${outlet.city ? ` (${outlet.city})` : ''}${outlet.status !== "ACTIVE" ? ` - ${outlet.status}` : ''}`
    }));

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (!isNowEditForm) {
                localStorage.removeItem("productId");
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isNowEditForm]);

    // Helper function to get current value
    const getValue = (fieldName) => {
        if (isNowEditForm) {
            return editedData[fieldName] !== undefined ? editedData[fieldName] : '';
        }
        return product[fieldName] !== undefined ? product[fieldName] : '';
    };

    return (
        <div className="add-product-step">
            <h6 className="mb-4 text-primary">
                {isNowEditForm ? 'Edit Product Details' : 'Step 1: Add Product Details'}
            </h6>

            <Row className="gy-3">
                {/* Basic Information */}
                <Col lg={6}>
                    <Card className="h-100 bg-white">
                        <Card.Body>
                            <h6 className="mb-3 fw-semibold">Basic Information</h6>

                            <Row className="gy-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Sequence Number <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            name="sequenceNumber"
                                            value={getValue('sequenceNumber')}
                                            onChange={handleChange}
                                            placeholder="Enter sequence"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Category <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="category"
                                            value={getValue('category')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Category</option>
                                            {categoryList.map(cat => (
                                                <option key={cat._id} value={cat._id}>{cat.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Product Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={getValue('name')}
                                            onChange={handleChange}
                                            placeholder="Enter product name"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Class Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="classType"
                                            value={getValue('classType')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="FOOD">FOOD</option>
                                            <option value="BEVERAGE">BEVERAGE</option>
                                            <option value="COMBOS">COMBOS</option>
                                            <option value="DESSERTS">DESSERTS</option>
                                            <option value="EXTRAS">EXTRAS</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Food Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="foodType"
                                            value={getValue('foodType')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Food Type</option>
                                            <option value="VEG">VEG</option>
                                            <option value="NON-VEG">NON-VEG</option>
                                            <option value="VEGAN">VEGAN</option>
                                            <option value="VEG/VEGAN">VEG/VEGAN</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Order Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="orderType"
                                            value={getValue('orderType') || "ALL"}
                                            onChange={handleChange}
                                        >
                                            <option value="ALL">ALL</option>
                                            <option value="DELIVERY">DELIVERY</option>
                                            <option value="PICKUP">PICK-UP</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Outlet Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="isEventProduct"
                                            value={getValue('isEventProduct')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Outlet Type</option>
                                            <option value="false">Regular Outlet</option>
                                            <option value="true">Event Outlet</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>New Product Badge <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="isNewProduct"
                                            value={getValue('isNewProduct')}
                                            onChange={handleChange}
                                        >
                                            <option value="" disabled>Select</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                {/* Is Freebie Product Field */}
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Is Freebie Product <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="isFreebieProduct"
                                            value={getValue('isFreebieProduct')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select</option>
                                            <option value="true">YES</option>
                                            <option value="false">NO</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Making Time (mins) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="makingTime"
                                            value={getValue('makingTime')}
                                            onChange={handleChange}
                                            placeholder="Enter time"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="description"
                                            value={getValue('description')}
                                            onChange={handleChange}
                                            placeholder="Enter product description"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Pricing & Media */}
                <Col lg={6}>
                    <Card className="h-100 bg-white">
                        <Card.Body>
                            <h6 className="mb-3 fw-semibold">Pricing & Media</h6>

                            <Row className="gy-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>MRP (₹) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="mrp"
                                            value={getValue('mrp')}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Offer Price (₹) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="offerPrice"
                                            value={getValue('offerPrice')}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Product Cost (₹)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="productCost"
                                            value={getValue('productCost') || 0}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Tax Percent (%) <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="taxPercent"
                                            value={getValue('taxPercent')}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Product Image <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            name="displayImage"
                                            onChange={handleChange}
                                            disabled={isNowEditForm} // Disable in edit mode if you don't want to change image
                                        />
                                        <Form.Text className="text-muted">
                                            Must be exactly 400x400 pixels
                                        </Form.Text>
                                        {displayPreview && (
                                            <img
                                                src={displayPreview}
                                                alt="preview"
                                                style={{ width: 120, height: 120, objectFit: 'cover', marginTop: 10, borderRadius: 6 }}
                                            />
                                        )}
                                        {isNowEditForm && !displayPreview && editedData.displayImage && (
                                            <div className="mt-2">
                                                <small className="text-muted">Current image:</small>
                                                <img
                                                    src={editedData.displayImage} // Assuming this is a URL
                                                    alt="current"
                                                    style={{ width: 120, height: 120, objectFit: 'cover', marginTop: 5, borderRadius: 6 }}
                                                />
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Cover Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            name="coverPicture"
                                            onChange={handleChange}
                                        />
                                        {coverPreview && (
                                            <img
                                                src={coverPreview}
                                                alt="preview"
                                                style={{ width: 120, height: 120, objectFit: 'cover', marginTop: 10, borderRadius: 6 }}
                                            />
                                        )}
                                        {isNowEditForm && !coverPreview && editedData.coverPicture && (
                                            <div className="mt-2">
                                                <small className="text-muted">Current cover:</small>
                                                <img
                                                    src={editedData.coverPicture}
                                                    alt="current cover"
                                                    style={{ width: 120, height: 120, objectFit: 'cover', marginTop: 5, borderRadius: 6 }}
                                                />
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>HSN Code <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="hsn"
                                            value={getValue('hsn')}
                                            onChange={handleChange}
                                            placeholder="Enter HSN"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Weight <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            name="weight"
                                            value={getValue('weight')}
                                            onChange={handleChange}
                                            placeholder="0.00"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Weight Unit <span className="text-danger">*</span></Form.Label>
                                        <Form.Select
                                            name="weightUnit"
                                            value={getValue('weightUnit')}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Unit</option>
                                            <option value="KG">KILOGRAMS</option>
                                            <option value="GMS">GRAMS</option>
                                            <option value="LITRES">LITRES</option>
                                            <option value="ML">MILLI-LITRE</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Calories <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="calories"
                                            value={getValue('calories')}
                                            onChange={handleChange}
                                            placeholder="Enter calories"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Product Tag</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={getValue('productTagName')}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setSearchText(value);
                                                if (isNowEditForm) {
                                                    setEditedData(prev => ({
                                                        ...prev,
                                                        productTagName: value
                                                    }));
                                                }
                                                updateData('product', { productTagName: value });
                                            }}
                                            placeholder="Type to search tags"
                                        />
                                        {productTags.length > 0 && (
                                            <div className="border rounded mt-1 p-2 bg-white shadow-sm">
                                                {productTags.map(tag => (
                                                    <div
                                                        key={tag._id}
                                                        className="p-2 border-bottom hover-bg cursor-pointer"
                                                        onClick={() => {
                                                            if (isNowEditForm) {
                                                                setEditedData(prev => ({
                                                                    ...prev,
                                                                    productTagId: tag._id,
                                                                    productTagName: tag.tagName
                                                                }));
                                                            }
                                                            updateData('product', {
                                                                productTagId: tag._id,
                                                                productTagName: tag.tagName
                                                            });
                                                            setProductTags([]);
                                                        }}
                                                    >
                                                        {tag.tagName}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Tags & Keywords */}
                <Col md={12}>
                    <Card className='bg-white'>
                        <Card.Body>
                            <h6 className="mb-3 fw-semibold">Tags & Keywords</h6>

                            <Row className="gy-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Excluded Outlets</Form.Label>
                                        <Select
                                            components={animatedComponents}
                                            isMulti
                                            options={outletOptions}
                                            value={isNowEditForm ? editSelectedExcludedOutlets : selectedExcludedOutlets}
                                            onChange={(selected) => {
                                                if (isNowEditForm) {
                                                    setEditSelectedExcludedOutlets(selected);
                                                } else {
                                                    setSelectedExcludedOutlets(selected);
                                                }
                                            }}
                                            placeholder="Select outlets to exclude"
                                            closeMenuOnSelect={false}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Product Nature</Form.Label>
                                        <TagsInput
                                            value={isNowEditForm ? editSelectedNature : selectedNature}
                                            onChange={(tags) => {
                                                if (isNowEditForm) {
                                                    setEditSelectedNature(tags);
                                                } else {
                                                    setSelectedNature(tags);
                                                }
                                            }}
                                            placeHolder="Add nature tags (Press Enter after each Nature)"
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Keywords <span className="text-danger">*</span></Form.Label>
                                        <TagsInput
                                            value={isNowEditForm ? editSelectedKeywords : selectedKeywords}
                                            onChange={(tags) => {
                                                console.log('Keywords changed:', tags); // Debug log
                                                if (isNowEditForm) {
                                                    setEditSelectedKeywords(tags);
                                                } else {
                                                    setSelectedKeywords(tags);
                                                }
                                            }}
                                            placeHolder="Add keywords (press Enter)"
                                            separators={['Enter', ',']} // Allow comma as separator too
                                            onRemoved={(tag) => {
                                                console.log('Tag removed:', tag); // Debug log
                                            }}
                                        />
                                        <Form.Text className="text-muted">
                                            Press Enter after each keyword
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <div className="mt-4 text-end">
                <Button
                    variant="primary"
                    onClick={handleNextStep}
                    disabled={isLoading || isSubmitting}
                >
                    {isLoading ? (
                        <>
                            <Spinner size="sm" animation="border" className="me-2" />
                            {isNowEditForm ? 'Updating Product...' : 'Creating Product...'}
                        </>
                    ) : (
                        `Next: Set Menu Group Pricing →`
                    )}
                </Button>
            </div>
        </div>
    );
};

export default AddProduct;